/**
 * Address Search Component
 * 
 * Handles address search functionality for the property valuation widget.
 */

import { searchAddresses } from '../services/geocodingService';

/**
 * Initialize address search functionality
 * @param {Object} widget The widget instance
 */
export function initializeAddressSearch(widget) {
  let searchTimeout;
  const addressInput = document.getElementById('addressInput');
  const addressResults = document.getElementById('addressResults');
  const step1Next = document.getElementById('step1Next');
  
  if (!addressInput || !addressResults) return;
  
  // Add event listener for address input
  addressInput.addEventListener('input', (event) => {
    const query = event.target.value;
    
    if (!query || query.trim() === '') {
      addressResults.style.display = 'none';
      if (step1Next) step1Next.disabled = true;
      return;
    }
    
    // Clear any existing timeout
    if (searchTimeout) clearTimeout(searchTimeout);
    
    // Set a timeout to avoid making too many requests while typing
    searchTimeout = setTimeout(() => {
      searchAddresses(query)
        .then(displayAddressResults)
        .catch(error => {
          console.error('Error fetching addresses:', error);
          addressResults.style.display = 'none';
        });
    }, 300);
  });
  
  /**
   * Display address search results
   * @param {Object} data The search results data
   */
  function displayAddressResults(data) {
    addressResults.innerHTML = '';
    
    if (!data.results || data.results.length === 0) {
      addressResults.style.display = 'none';
      return;
    }
    
    // Add each result to the container
    data.results.forEach(result => {
      const addressItem = document.createElement('div');
      addressItem.className = 'address-result-item';
      addressItem.textContent = result.attrs.label;
      
      // Handle click on address item
      addressItem.addEventListener('click', () => {
        widget.handleAddressSelection(result);
      });
      
      addressResults.appendChild(addressItem);
    });
    
    // Show the results container
    addressResults.style.display = 'block';
  }
  
  // Add event listener to close address results when clicking outside
  document.addEventListener('click', (event) => {
    if (event.target !== addressResults && event.target !== addressInput && addressResults) {
      addressResults.style.display = 'none';
    }
  });
}